//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import unity from "@/unity/unity";
const moment = require('moment-timezone');

export default {
  data() {
    return {
      langQ: "English",
      langshow: {
        email_address: "Email Address",
        title: "Title*",
        first_name: "FirstName*",
        last_name: "LastName*",
        age: "Age",
        date_of_birth: "Date of Birth",
        nationality: "Nationality",
        t_id: "Thai Identification Number",
        p_no: "Passport No.",
        phone_n: "Phone Number*",
        status_show: "This training is not yet open for register",
        Check_your_email: "Check your Email",
        Check: "Check",
        Verify: "Verify",
        Register: "Register",
        Please_input_valid_email_address: "Please input valid email address",
        This_email_has_already_registered_for_this_training: "This email has already registered for this training.",
        An_OTP_has_been_sent_to_our_email: "An OTP has been sent to our email",
        Invalid_email_format_Please_enter_a_valid_email : "Invalid email format. Please enter a valid email.",
        Invalid_OTP_Please_try_again : "Invalid OTP. Please try again.",
        Informations_Fail : "Informations Fail",
        Failed_to_save_data : "Failed to save data",
        Please_enter_OTP_sent_to_your_email : "Please enter OTP sent to your email.",
        Email_Verified : "Email Verified",
        Verify_Email_successfully : "Verify Email successfully",
        Invalid_Information : "Invalid Information",
        Please_Enter_New_Thai_Identification_Number_Data : "Please Enter New Thai Identification Number Data",
        Please_Enter_Title_Data : "Please Enter Title Data",
        Please_Enter_FirstName_Data : "Please Enter FirstName Data",
        Please_Enter_LastName_Data : "Please Enter LastName Data",
        Please_Enter_Phone_Number : "Please Enter Phone Number Data",
        Information_Sent : "Information Sent",
        Your_information_has_been_sen : "Your information has been sen",
        This_email_is_already_registered : "This email is already registered,",
        do_you_want_to_use: "do you want to use",
        this_email_to_register_for: "this email to register for ",
        last_popup: ""
      },
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      title_name: "",
      check_prename_th: true,
      check_prename_en: true,
      langQ_list: ["Thai","English"],
      prename_th_list: ["นาย","นาง","นางสาว","อื่นๆ"],
      prename_en_list: ["Mr.","Mrs.","Miss.","Other"],
      menu_date: false,
      check_status_tranning: false,
      header_list: [],
      footer_list: [],
      email: "",
      check_email: false,
      otp: "",
      check_otp: false,
      dialogOldEmail: false,
      email_disable: false,
      dataitem: {
        prename_th: "",
        first_name_th: "",
        last_name_th: "",
        birth_day: null,
        age: 0,
        nationality: "",
        id_card_number: "",
        passport_number: "",
        phone_number: "",
        image: ""
      },
      imageUrl: "https://upload.wikimedia.org/wikipedia/en/2/24/Crystal_personal.svg",
      data_tranning: {},
      email_id: 0,
      tu_user_id: 0,
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    computedDateRes() {
      return unity.formatDate(this.dataitem.birth_day);
    },
  },
  watch: {
  },
  async mounted() {
    this.$hideLoader();
    this.loadData();
    this.$hideLoader();
  },
  methods: {

    async setlanguage(){
      console.log(this.langQ)
      if(this.langQ == "Thai"){
        this.langshow.email_address = "อีเมล";
        this.langshow.title = "คำนำหน้า*";
        this.langshow.first_name = "ชื่อ*";
        this.langshow.last_name = "นามสกุล*";
        this.langshow.age = "อายุ";
        this.langshow.date_of_birth = "วันเกิด";
        this.langshow.nationality = "สัญชาติ";
        this.langshow.t_id = "เลขบัตรประชาชนไทย";
        this.langshow.p_no = "เลขพาสปอร์ต";
        this.langshow.phone_n = "หมายเลขโทรศัพท์*";
        this.langshow.status_show = "ยังไม่มีการเปิดอบรม";
        this.langshow.Check_your_email = "ตรวจสอบอีเมล";
        this.langshow.Check = "ตรวจสอบ";
        this.langshow.Verify = "ตรวจสอบ";
        this.langshow.Register = "ลงทะเบียน";
        this.langshow.Please_input_valid_email_address = "กรุณาเพิ่มข้อมูลอีเมล";
        this.langshow.This_email_has_already_registered_for_this_training = "อีเมลนี้ได้ลงทะเบียนสำหรับการฝึกอบรมนี้แล้ว";
        this.langshow.An_OTP_has_been_sent_to_our_email = "เราได้ส่งรหัส OTP ไปที่อีเมลของคุณ";
        this.langshow.Invalid_email_format_Please_enter_a_valid_email = "รูปแบบอีเมลไม่ถูกต้อง กรุณาใส่อีเมลที่ถูกต้อง";
        this.langshow.Invalid_OTP_Please_try_again = "รหัส OTP ไม่ถูกต้อง กรุณาลองอีกครั้ง";
        this.langshow.Informations_Fail = "ข้อมูลล้มเหลว";
        this.langshow.Failed_to_save_data = "บันทึกข้อมูลไม่สำเร็จ";
        this.langshow.Please_check_OTP_your_email = "กรุณาตรวจสอบ รหัส OTP ในอีเมลของคุณ";
        this.langshow.Email_Verified = "อีเมลได้รับการยืนยันแล้ว";
        this.langshow.Verify_Email_successfully = "ยืนยังอีเมลสำเร็จ";
        this.langshow.Invalid_Information = "ตรวจสอบข้อมูล";
        this.langshow.Please_Enter_New_Thai_Identification_Number_Data = "กรุณาข้อมูลบัตรประชาชนไทย";
        this.langshow.Please_Enter_Title_Data = "กรุณาข้อมูลคำนำหน้า";
        this.langshow.Please_Enter_FirstName_Data = "กรุณาข้อมูลชื่อ";
        this.langshow.Please_Enter_LastName_Data = "กรุณาข้อมูลนามสกุล";
        this.langshow.Please_Enter_Phone_Number = "กรุณาข้อมูลเบอร์โทรศัพท์";
        this.langshow.Information_Sent = "ส่งข้อมูลสำเร็จ";
        this.langshow.Your_information_has_been_sen = "ข้อมูลของได้ถูกส่งแล้วเรียบร้อย";
        this.langshow.This_email_is_already_registered = "อีเมลนี้มีการสมัครสมาชิกอยู่เเล้ว";
        this.langshow.do_you_want_to_use = "คุณต้องการสมัคร การอบรม";
        this.langshow.this_email_to_register_for = "";
        this.langshow.last_popup = "ด้วย สมาชิกเดิมหรือไหม";
      }else{
        this.langshow.email_address = "Email Address";
        this.langshow.title = "Title*";
        this.langshow.first_name = "FirstName*";
        this.langshow.last_name = "LastName*";
        this.langshow.age = "Age";
        this.langshow.date_of_birth = "Date of Birth";
        this.langshow.nationality = "Nationality";
        this.langshow.t_id = "Thai Identification Number";
        this.langshow.p_no = "Passport No.";
        this.langshow.phone_n = "Phone Number*";
        this.langshow.status_show = "This training is not yet open for register";
        this.langshow.Check_your_email = "Check your Email";
        this.langshow.Check = "Check";
        this.langshow.Verify = "Verify";
        this.langshow.Register = "Register";
        this.langshow.Please_input_valid_email_address = "Please_input_valid_email_address";
        this.langshow.This_email_has_already_registered_for_this_training = "This email has already registered for this training.";
        this.langshow.An_OTP_has_been_sent_to_our_email = "An OTP has been sent to our email";
        this.langshow.Invalid_email_format_Please_enter_a_valid_email = "Invalid email format. Please enter a valid email.";
        this.langshow.Invalid_OTP_Please_try_again = "Invalid OTP. Please try again.";
        this.langshow.Informations_Fail = "Informations Fail";
        this.langshow.Failed_to_save_data = "Failed to save data";
        this.langshow.Please_check_OTP_your_email = "Please check OTP your email";
        this.langshow.Email_Verified = "Email Verified";
        this.langshow.Verify_Email_successfully = "Verify Email successfully";
        this.langshow.Invalid_Information = "Invalid Information";
        this.langshow.Please_Enter_New_Thai_Identification_Number_Data = "Please Enter New Thai Identification Number Data";
        this.langshow.Please_Enter_Title_Data = "Please Enter Title Data";
        this.langshow.Please_Enter_FirstName_Data = "Please Enter FirstName Data";
        this.langshow.Please_Enter_LastName_Data = "Please Enter LastName Data";
        this.langshow.Please_Enter_Phone_Number = "Please Enter Phone Number Data";
        this.langshow.Information_Sent = "Information Sent";
        this.langshow.Your_information_has_been_sen = "Your information has been sen";
        this.langshow.This_email_is_already_registered = "This email is already registered,";
        this.langshow.do_you_want_to_use = "do you want to use";
        this.langshow.this_email_to_register_for = "this email to register for ";
        this.langshow.last_popup = "";
      }
    },
    async loadData(){
      const res_data = await api.getTRANNING_HById(this.$route.params.tranning_id)
      console.log("res_data.data")
      console.log(res_data.data)
      if(res_data.data.length > 0){

        this.check_status_tranning = true;
        this.data_tranning = res_data.data[0];
        this.title_name = res_data.data[0].tranning_name;

        const res_h = await api.getTRANNING_DByIdType(this.$route.params.tranning_id,"Header")
        const res_f = await api.getTRANNING_DByIdType(this.$route.params.tranning_id,"Footer")


        this.header_list = res_h.data;
        console.log(res_f.data)
        this.footer_list = res_f.data;
      }
    },

    async checkEmail(){
      if (this.email == "") {
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Check_your_email}`,
              `${this.langshow.Please_input_valid_email_address}`,
              "text-h5 red--text text-center"
          );
          this.$refs["email"].focus();
          return;
      }
      this.$showLoader()
      const check_email_cond = await api.getDataEmailByEmailSQL(this.email)
      this.$hideLoader();
      console.log("check_email_cond.data")
      console.log(check_email_cond.data)

      let check_t = 0;
      if(check_email_cond.data.length >0){
        for (const [index, item] of check_email_cond.data.entries()){
          if(item.tranning_id == this.$route.params.tranning_id){
            check_t = 1;
          }

        }
        if(check_t == 1){
          this.email="";

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            `${this.langshow.Check_your_email}`,
            `${this.langshow.This_email_has_already_registered_for_this_training}`,
            "text-h5 red--text text-center"
          );
          this.$refs["email"].focus();
          return;
        }
      }

      if(check_email_cond.data.length > 0 && check_email_cond.data[0].status == 2){
          this.tu_user_id = check_email_cond.data[0].tu_id;
          this.dialogOldEmail = true;
      } else{
        await this.checkEmailaction();
      }

    },
    async checkEmailaction(){
      
        let data = { email: "",}
        data.email = this.email;

        this.$showLoader()

        const res_check = await api.confirmemailRegister(data);

        if(res_check.status == 200){

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            `${this.langshow.Check_your_email}`,
            `${this.langshow.An_OTP_has_been_sent_to_our_email}`,
            "text-h5 green--text text-center"
          );
          this.$hideLoader();
          this.check_otp = true;
        }
    },

    async AddOldEmailConfirm(){
      this.dialogOldEmail = false;
      await this.checkEmailaction();
    },

    async closeOldEmail(){
      this.dialogOldEmail = false;
      this.email = "";

    },
    async checkEmailFormat() {
      if (this.email.trim() !== "") {
        // ใช้ Regex ที่ถูกต้องเพื่อตรวจสอบรูปแบบของอีเมล
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!emailPattern.test(this.email.trim())) {
          // รูปแบบของอีเมลไม่ถูกต้อง
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            `${this.langshow.Check_your_email}`,
            `${this.langshow.Invalid_email_format_Please_enter_a_valid_email}`,
            "text-h5 red--text text-center"
          );
          this.$refs["email"].focus();
          return;
        }else{
          await this.checkEmail()
        }
      }
    },
    async checkNumber(){
      if(this.otp != ""){
        if (!/^[0-9]{0,6}$/.test(this.otp.trim())) {
          this.otp = "";
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Check_your_email}`,
              `${this.langshow.Invalid_OTP_Please_try_again}`,
              "text-h5 red--text text-center"
          );
          this.$refs["otp"].focus();
          return;
        }
      }
    },
    async checkIDCardNumber(){
      if(this.dataitem.id_card_number != ""){
        if (!/^[0-9]{0,13}$/.test(this.dataitem.id_card_number.trim())) {
          this.dataitem.id_card_number = "";
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Invalid_Information}`,
              `${this.langshow.Please_Enter_New_Thai_Identification_Number_Data}`,
              "text-h5 red--text text-center"
          );
          this.$refs["id_card_number"].focus();
          return;
        }
      }
    },
    async checkPhoneNumber(){
      if(this.dataitem.phone_number != ""){
        if (!/^[0-9]{0,10}$/.test(this.dataitem.phone_number.trim())) {
          this.dataitem.phone_number = "";
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Check_your_email}`,
              "Please Enter New Phone Number Data",
              "text-h5 red--text text-center"
          );
          this.$refs["phone_number"].focus();
          return;
        }
      }
    },
    async checkPasspost(){
      if(this.dataitem.passport_number != ""){
        if (!/^[0-9]{0,10}$/.test(this.dataitem.passport_number.trim())) {
          this.dataitem.passport_number = "";
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Check_your_email}`,
              "Please Enter New Passport No.",
              "text-h5 red--text text-center"
          );
          this.$refs["passport_number"].focus();
          return;
        }
      }
    },

    async VerifyEmail(){
      if (this.otp.trim() == "") {
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Check_your_email}`,
              `${this.langshow.Please_check_OTP_your_email}`,
              "text-h5 red--text text-center"
          );
          this.$refs["otp"].focus();
          return;
      }
      let  data_ver = {
        email: "",
        otp_number: ""
      }
      data_ver.email = this.email.trim();
      data_ver.otp_number = this.otp.trim();

      // this.$showLoader();

      const res_ver = await api.verifyemailRegister(data_ver);

      console.log("res_ver.data")
      console.log(res_ver.data)
      if(res_ver.status == 200){
        this.email_id = res_ver.data.email_id;
        this.$hideLoader();
        if(res_ver.data.action_check){

          this.$showLoader();
          var data_user_o = {
            t_user_id: this.tu_user_id,
            tranning_id: this.$route.params.tranning_id,
          }

          const res_add_user_o =  await api.addTRANNING_USER_D(data_user_o);

          if(res_add_user_o.status == 200 || res_add_user_o.status == 201){
            this.$hideLoader();
            this.$store.state.navMenu = false;
            this.$store.dispatch("doLogout");

            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              `${this.langshow.Information_Sent}`,
              `${this.langshow.Your_information_has_been_sen}`,
              "text-h5 green--text text-center",
              `/login`
            );
          }else{
            this.$hideLoader()
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Information_Sent}`,
              `${this.langshow.Failed_to_save_data}`,
              "text-h5 red--text text-center"
            );
            return;
          }
        }else{
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            `${this.langshow.Email_Verified}`,
            `${this.langshow.Verify_Email_successfully}`,
            "text-h5 green--text text-center",
          );
          this.check_otp = false
          this.email_disable = true;
          this.check_email = true;
        }
      }else if(res_ver.status == 204){
                this.$hideLoader();
                this.$store.state.global_push_dialog = true;
                this.setupAlertDialog(
                    true,
                    `${this.langshow.Informations_Fail}`,
                    `${this.langshow.Invalid_OTP_Please_try_again}`,
                    "text-h5 red--text text-center"
                );
                this.otp = ""
                this.$refs["otp"].focus();
                return;
      }else{
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          `${this.langshow.Informations_Fail}`,
          `${this.langshow.Failed_to_save_data}`,
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async setPreOhter(){

      if(this.dataitem.prename_th == "อื่นๆ"){
        this.check_prename_th = false;
      }else{
        this.dataitem.pre_ohter_th = "";
        this.check_prename_th = true;
      }

      if(this.dataitem.prename_en == "Other"){
        this.check_prename_en = false;
      }else{
        this.dataitem.pre_ohter_en = "";
        this.check_prename_en = true;
      }

    },
    onFileSelected(event) {
      const file = event.target.files[0];
      this.dataitem.image = event.target.files[0];
      this.imageUrl = URL.createObjectURL(file);
    },
    async saveItem(){
      // console.log("this.dataitem:")
      // console.log(this.dataitem)
      if(this.dataitem.prename_th == ""){
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Invalid_Information}`,
              `${this.langshow.Please_Enter_Title_Data}`,
              "text-h5 red--text text-center"
          );
          this.$refs["prename_th"].focus();
          return;
      }
      if(this.dataitem.first_name_th == ""){
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Invalid_Information}`,
              `${this.langshow.Please_Enter_FirstName_Data}`,
              "text-h5 red--text text-center"
          );
          this.$refs["first name"].focus();
          return;
      }
      if(this.dataitem.last_name_th == ""){
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Invalid_Information}`,
              `${this.langshow.Please_Enter_LastName_Data}`,
              "text-h5 red--text text-center"
          );
          this.$refs["last name"].focus();
          return;
      }
      if(this.dataitem.phone_number == ""){
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              `${this.langshow.Invalid_Information}`,
              `${this.langshow.Please_Enter_Phone_Number}`,
              "text-h5 red--text text-center"
          );
          this.$refs["phone_number"].focus();
          return;
      }
      let formData = new FormData();

      formData.append("emp_i_d", "");
      formData.append("user_role","");
      formData.append("username", this.email);
      formData.append("password", this.dataitem.phone_number);
      formData.append("email", this.email);
      formData.append("phone", this.dataitem.phone_number);
      formData.append("prename_t_h", this.dataitem.prename_th);
      formData.append("firstname", this.dataitem.first_name_th);
      formData.append("lastname", this.dataitem.last_name_th);
      formData.append("prename_e_n", this.dataitem.prename_th);
      formData.append("firstname_e_n", this.dataitem.first_name_th);
      formData.append("lastname_e_n", this.dataitem.last_name_th);

      let abb = "";
      abb = this.dataitem.first_name_th.split("")[0] + this.dataitem.last_name_th.split("")[0];
      formData.append("abbname_e_n", abb);

      //รอดึงค่า
      formData.append("company_i_d", this.data_tranning.company_id);
      formData.append("department_i_d", this.data_tranning.department_id);
      formData.append("position_i_d", this.data_tranning.position_id);
      formData.append("authorize_id", this.data_tranning.authorize_id);

      formData.append("emp_rate", 0);
      formData.append("emp_status", "T");
      console.log("this.dataitem.image")
      console.log(this.dataitem.image)
      formData.append("image", this.dataitem.image);
      formData.append("approver_level1", this.data_tranning.admin_id);
      formData.append("approver_level2", 0);
      formData.append("approver_level3", 0);
      formData.append("ip_authentication", "");
      formData.append("signature", "");
      formData.append("user_create", 0);
      formData.append("user_update", 0);

      this.$showLoader()
      const res_add = await api.addUserAccount(formData);
      console.log(res_add.data)

      if(res_add.status == 200 || res_add.status == 201){

     

        //create user
        let dataAdd_user = {
          user_id: 0,
          tranning_id: 0,
          te_id: 0,
          email: "",
          date: "",
          pre_name_th: "",
          first_name_th: "",
          last_name_th: "",
          birth_day: "",
          age: 0,
          nationality: "",
          id_card_number: "",
          phone_number: "",
          passport_number: ""
        }

        dataAdd_user.user_id = res_add.data.id;
        dataAdd_user.te_id = this.email_id;
        dataAdd_user.email = this.email;
        dataAdd_user.date = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
        dataAdd_user.pre_name_th = this.dataitem.prename_th;
        dataAdd_user.first_name_th = this.dataitem.first_name_th;
        dataAdd_user.last_name_th = this.dataitem.last_name_th;
        dataAdd_user.birth_day = this.dataitem.birth_day;
        dataAdd_user.age = this.dataitem.age;
        dataAdd_user.nationality = this.dataitem.nationality;
        dataAdd_user.id_card_number = this.dataitem.id_card_number;
        dataAdd_user.phone_number = this.dataitem.phone_number;
        dataAdd_user.passport_number = this.dataitem.passport_number;

        console.log("dataAdd_user: ")
        console.log(dataAdd_user)

        const res_add_user = await api.addTRANNING_USER(dataAdd_user)

        if(res_add_user.status == 200 || res_add_user.status == 201){
          let data_user_d = {
            t_user_id: res_add_user.data.id,
            tranning_id: this.$route.params.tranning_id,
          }
          await api.addTRANNING_USER_D(data_user_d);

          let data_send_m = {
            email: this.email,
            fist_name: this.dataitem.first_name_th,
            user_name: this.email,
            password: ""
          }

          data_send_m.password = this.dataitem.phone_number

          await api.sendUserRegister(data_send_m)
          await api.UpdateTranningEmail(this.email_id,{"status": 2});
          this.$hideLoader();
          this.$store.state.navMenu = false;
          this.$store.dispatch("doLogout");
          
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            `${this.langshow.Information_Sent}`,
            `${this.langshow.Your_information_has_been_sen}`,
            "text-h5 green--text text-center",
            `/login`
          );

        }else{
          this.$hideLoader()
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            `${this.langshow.Information_Sent}`,
            `${this.langshow.Failed_to_save_data}`,
            "text-h5 red--text text-center"
          );
          return;
        }
      }else{
          this.$hideLoader()
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            `${this.langshow.Information_Sent}`,
            `${this.langshow.Failed_to_save_data}`,
            "text-h5 red--text text-center"
          );
          return;
      }

    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
      },
  },
  async beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = false;

    // this.showdefaultsignature();
  },
  async created() {
  },
};
